import { Countries } from "@features/seo/seo.constants";

export const COUNTRY_MAP: Record<string, Countries> = {
    russia: Countries.RU,
    kazakhstan: Countries.KZ,
    belarus: Countries.BY,
    germany: Countries.DE
};